module.exports = __webpack_public_path__ + "img/concung.594406ce.png";